import { io, Socket } from "socket.io-client";
import { getAuthToken } from "@/lib/authCookies";
import { getSocketBaseUrl } from "@/lib/chatSocket";

let notificationSocket: Socket | null = null;

export const getNotificationSocket = (token: string): Socket => {
    if (!notificationSocket) {
        notificationSocket = io(`${getSocketBaseUrl()}/notifications`, {
            auth: { token },
            transports: ["websocket"],
            reconnection: true,
            reconnectionAttempts: 10,
        });
        notificationSocket.io.on("reconnect_attempt", () => {
            const latestToken = getAuthToken();
            if (latestToken) notificationSocket!.auth = { token: latestToken };
        });
    }
    return notificationSocket;
};

export const reconnectNotificationSocket = (token: string): void => {
    if (!notificationSocket) return;
    notificationSocket.auth = { token };
    if (notificationSocket.connected) notificationSocket.disconnect();
    notificationSocket.connect();
};

export const disconnectNotificationSocket = (): void => {
    notificationSocket?.disconnect();
    notificationSocket = null;
};
